// extracted by mini-css-extract-plugin
export var spinner = "Ugo4r29e";
export var rotate = "W4AIoR36";
export var path = "dca-dIHZ";
export var dash = "kyldFC+S";